import { Button, Spin } from "antd";
import * as React from "react";
import { withRouter } from "react-router";
import { connect } from "react-redux";
import { alertError } from "../../utils/alert";
import { getDeletedBatchInventory } from "../../Graphs/Card/getDeletedBatchInventory";
import { Table } from "antd";

var moment = require("moment");

class RedeemCodeDataDownload extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      data: [],
      dataTotal: 0,
      isLoading: false,
      startIndex: 0,
      limitNumber: 5,
      pagination: {
        pageSize: 5,
        current: 1,
      },
    };
    this.dateFormat = this.dateFormat.bind(this);
    this.handleTableChange = this.handleTableChange.bind(this);
  }

  componentDidMount() {
    this.listCardRedeemData(0, 5);
  }

  // getLimitedRedeem = async (pagination) => {
  //   const start =
  //     pagination.current * pagination.pageSize - pagination.pageSize;
  //   const end = pagination.pageSize;

  //   this.setState(
  //     {
  //       isLoading: true,
  //       startIndex: start,
  //       limitNumber: end,
  //     },
  //     async () => {
  //       this.listCardRedeemData(start, end);
  //     }
  //   );
  // };

  listCardRedeemData = async (start, end) => {
    try {
      const { authToken } = this.props;
      this.setState({
        isLoading: true,
      });
      const { loginUserData } = this.props;

      let city = loginUserData.role == "Sub_admin" ? loginUserData.city : "";

      let cardRedeemData = await getDeletedBatchInventory(
        authToken,
        this.props.data.id,
        city
      );

      if (cardRedeemData.status === 200) {
        this.setState({
          isLoading: false,
          data: cardRedeemData.data,
          dataTotal: cardRedeemData.total,
        });
      } else if (cardRedeemData.status === 401) {
        this.props.expireToken();
        this.props.onClose();
        throw cardRedeemData && cardRedeemData.message
          ? cardRedeemData.message
          : "Error";
      } else {
        this.props.onClose();
        throw cardRedeemData && cardRedeemData.message
          ? cardRedeemData.message
          : "Error";
      }
    } catch (e) {
      alertError("REDEEM", e);
    } finally {
      this.setState({
        isLoading: false,
      });
    }
  };

  handleTableChange(pagination, filters) {
    this.setState(
      {
        pagination,
      },
      () => this.getLimitedRedeem(pagination)
    );
  }

  dateFormat(date) {
    var oldDate = new Date(date),
      momentObj = moment(oldDate).utc(),
      newDate = momentObj.add(2, "hours").format("Do MMM YYYY");

    return newDate;
  }

  // ----------------- ADDED: generateCsv -----------------
  // generateCsv = async () => {
  //   try {
  //     const { data } = this.state;

  //     if (!data || data.length === 0) {
  //       return;
  //     }

  //     this.setState({ isLoading: true });

  //     const escapeCsv = (value) => {
  //       if (value === null || value === undefined) return "";
  //       const str = String(value);
  //       return `"${str.replace(/"/g, '""')}"`;
  //     };

  //     const rows = [];
  //     rows.push([
  //       "Sr.No.",
  //       "Card Name",
  //       "User Name",
  //       "Serial Number",
  //       "Redeem Code",
  //       "Added By",
  //       "Paid",
  //       "Order Code",
  //       "Reference Id",
  //     ]);

  //     data.forEach((item, idx) => {
  //       const cardName = item.card && item.card.name ? item.card.name : "-";
  //       const userName =
  //         item.user && item.user.first_name ? item.user.first_name : "-";
  //       const serialNumber = item.serial_number ? item.serial_number : "-";
  //       const redeemCode = item.redeem_code ? item.redeem_code : "-";
  //       const addedByRaw = item.added_by ? item.added_by : "-";
  //       const addedBy =
  //         redeemCode && addedByRaw === "sub_admin" ? "Sub Admin" : addedByRaw;
  //       const paid = item.is_paid ? "PAID" : "UNPAID";
  //       let orderCode = "-";
  //       let referenceId = "-";
  //       if (item.is_paid) {
  //         if (item.user_transaction !== null) {
  //           orderCode = item.user_transaction.order_code || "-";
  //           referenceId = item.user_transaction.reference_id || "-";
  //         } else if (item.user_wallet_transaction !== null) {
  //           orderCode = item.user_wallet_transaction.order_code || "-";
  //           referenceId = item.user_wallet_transaction.reference_id || "-";
  //         }
  //       }

  //       rows.push([
  //         idx + 1,
  //         cardName,
  //         userName,
  //         serialNumber,
  //         redeemCode,
  //         addedBy,
  //         paid,
  //         orderCode,
  //         referenceId,
  //       ]);
  //     });

  //     // Build CSV content
  //     let csvContent = "data:text/csv;charset=utf-8,";
  //     rows.forEach((rowArray) => {
  //       // escape each cell
  //       const line = rowArray.map((cell) => escapeCsv(cell)).join(",");
  //       csvContent += line + "\r\n";
  //     });

  //     const csvName = `redeem_codes_${moment().format("YYYYMMDD_HHmmss")}.csv`;
  //     const encodedUri = encodeURI(csvContent);
  //     const link = document.createElement("a");
  //     link.setAttribute("href", encodedUri);
  //     link.setAttribute("download", csvName);
  //     document.body.appendChild(link);
  //     link.click();
  //     document.body.removeChild(link);
  //   } catch (e) {
  //     alertError("REDEEM", e);
  //   } finally {
  //     this.setState({ isLoading: false });
  //   }
  // };
  // ------------------------------------------------------

  generateCsv = async () => {
    try {
      this.setState({ isLoading: true });

      const { authToken, loginUserData } = this.props;

      let city = loginUserData.role === "Sub_admin" ? loginUserData.city : "";

      const response = await getDeletedBatchInventory(
        authToken,
        this.props.data.id,
        city
      );

      if (
        response.status !== 200 ||
        !response.data ||
        response.data.length === 0
      ) {
        this.setState({ isLoading: false });
        return;
      }

      const allData = response.data;

      // 2️⃣ CSV escape function
      const escapeCsv = (value) => {
        if (value === null || value === undefined) return "";
        const str = String(value);
        return `"${str.replace(/"/g, '""')}"`;
      };

      // 3️⃣ CSV rows
      const rows = [];

      rows.push([
        "Sr.No.",
        "Card Name",
        "User Name",
        "Serial Number",
        "Redeem Code",
        "Added By",
        "Paid",
        "Order Code",
        "Reference Id",
      ]);

      allData.forEach((item, idx) => {
        const cardName = item.card?.name || "-";
        const userName = item.user?.first_name || "-";
        const serialNumber = item.serial_number || "-";
        const redeemCode = item.redeem_code || "-";

        const addedByRaw = item.added_by || "-";
        const addedBy =
          redeemCode && addedByRaw === "sub_admin" ? "Sub Admin" : addedByRaw;

        const paid = item.is_paid ? "PAID" : "UNPAID";

        let orderCode = "-";
        let referenceId = "-";

        if (item.is_paid) {
          if (item.user_transaction) {
            orderCode = item.user_transaction.order_code || "-";
            referenceId = item.user_transaction.reference_id || "-";
          } else if (item.user_wallet_transaction) {
            orderCode = item.user_wallet_transaction.order_code || "-";
            referenceId = item.user_wallet_transaction.reference_id || "-";
          }
        }

        rows.push([
          idx + 1,
          cardName,
          userName,
          serialNumber,
          redeemCode,
          addedBy,
          paid,
          orderCode,
          referenceId,
        ]);
      });

      // 4️⃣ Convert to CSV string
      const csvContent = rows
        .map((row) => row.map((cell) => escapeCsv(cell)).join(","))
        .join("\r\n");

      // 5️⃣ Download CSV using Blob
      const csvName = `redeem_codes_${moment().format("YYYYMMDD_HHmmss")}.csv`;

      const blob = new Blob([csvContent], {
        type: "text/csv;charset=utf-8;",
      });

      const url = URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.download = csvName;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      URL.revokeObjectURL(url);
    } catch (e) {
      alertError("REDEEM", e);
    } finally {
      this.setState({ isLoading: false });
    }
  };

  counter = 0;
  tempCounter = 0;
  columns = [
    {
      title: "Sr. No.",
      key: "serial_number",
      fixed: true,
      render: (text, item, index) => {
        return (
          <div>
            <span>{++index + this.tempCounter}</span>
          </div>
        );
      },
    },
    {
      title: "Card Name",
      key: "card_name",
      fixed: true,
      render: (text, item, index) => {
        return (
          <div>
            <div
              style={{
                alignItems: "center",
                display: "inline-block",
                width: "100%",
              }}
            >
              <div flexDirection="column">
                <strong>
                  {" "}
                  <div>
                    {item.card ? (item.card.name ? item.card.name : "-") : "-"}
                  </div>
                </strong>
              </div>
            </div>
          </div>
        );
      },
    },
    {
      title: "User Name",
      key: "user_name",
      render: (text, item, index) => {
        return (
          <div>
            <div
              style={{
                alignItems: "center",
                display: "inline-block",
                width: "100%",
              }}
            >
              <div flexDirection="column">
                <strong>
                  {" "}
                  <div>
                    {item.user
                      ? item.user.first_name
                        ? item.user.first_name
                        : "-"
                      : "-"}
                  </div>
                </strong>
              </div>
            </div>
          </div>
        );
      },
    },
    {
      title: "Serial Number",
      key: "serial_num",
      dataIndex: "serial_number",
      render: (text, item, index) => {
        return <div>{item.serial_number ? item?.serial_number : "-"}</div>;
      },
    },
    {
      title: "Redeem Code",
      key: "redeem_code",
      dataIndex: "redeem_code",
      render: (text, item, index) => {
        return <div>{item.redeem_code ? item.redeem_code : "-"}</div>;
      },
    },
    {
      title: "Added By",
      key: "added_by",
      dataIndex: "added_by",
      render: (text, item, index) => {
        return (
          <div>
            {item.redeem_code
              ? text === "sub_admin"
                ? "Sub Admin"
                : text
              : "-"}
          </div>
        );
      },
    },
    {
      title: "Paid",
      key: "paid",
      render: (text, item, index) => {
        return (
          <div>
            <div
              style={{
                alignItems: "center",
                display: "inline-block",
                width: "100%",
              }}
            >
              <div flexDirection="column">
                <div>{item.is_paid ? "PAID" : "UNPAID"}</div>
              </div>
            </div>
          </div>
        );
      },
    },
    {
      title: "Order Code",
      key: "order_code",
      render: (text, item, index) => {
        return (
          <div>
            <div
              style={{
                alignItems: "center",
                display: "inline-block",
                width: "100%",
              }}
            >
              <div flexDirection="column">
                <div>
                  {item.is_paid
                    ? item.user_transaction !== null
                      ? item.user_transaction.order_code
                      : item.user_wallet_transaction !== null
                      ? item.user_wallet_transaction.order_code
                      : "-"
                    : "-"}
                </div>
              </div>
            </div>
          </div>
        );
      },
    },
    {
      title: "Reference Id",
      key: "reference_id",
      render: (text, item, index) => {
        return (
          <div>
            <div
              style={{
                alignItems: "center",
                display: "inline-block",
                width: "100%",
              }}
            >
              <div flexDirection="column">
                <div>
                  {item.is_paid
                    ? item.user_transaction !== null
                      ? item.user_transaction.reference_id
                      : item.user_wallet_transaction !== null
                      ? item.user_wallet_transaction.reference_id
                      : "-"
                    : "-"}
                </div>
              </div>
            </div>
          </div>
        );
      },
    },
  ];
  render() {
    const { isLoading, data, dataTotal } = this.state;
    return isLoading ? (
      <div style={{ marginLeft: "20px" }}>
        <Spin size="large" style={{ margin: "0 auto", width: "100%" }} />
      </div>
    ) : (
      <>
        <div style={{ height: "350px", overflow: "auto" }}>
          <Table
            dataSource={data}
            columns={this.columns}
            isLoading={this.state.isLoading}
            pagination={false}
            scroll={{ x: 1000 }}
          />
          {/* <p className="mt-2 text-warning fw-bold">
          Note: Only visible data will be downloaded as CSV.
          </p> */}
        </div>
        <Button
          style={{
            marginTop: "10px",
            background: "#5C6AC4",
            color: "#fff",
            cursor: "pointer",
            marginLeft: "15px",
          }}
          onClick={() => {
            this.generateCsv();
          }}
        >
          Generate CSV
        </Button>
      </>
    );
  }
}

const mapStateToProps = (state) => ({
  authToken: state.auth.authToken,
});

const mapDispatchToProps = (dispatch) => {
  return {
    setLoginFlag: (flag) => {
      dispatch({
        type: "SET_LOGIN_FLAG",
        flag: flag,
      });
    },
    setUserData: (userData) => {
      dispatch({
        type: "SET_USER_DATA",
        userData: userData,
      });
    },
    setUserToken: (authToken) => {
      dispatch({
        type: "SET_USER_AUTHTOKEN",
        authToken: authToken,
      });
    },
    // setListCardData: (listCardData) => {
    //   dispatch({
    //     type: "SET_LIST_CARD_DATA",
    //     listCardData: listCardData,
    //   });
    // },
    // setListCardDataTotal: (listCardDataTotal) => {
    //   dispatch({
    //     type: "SET_LIST_CARD_DATA_TOTAL",
    //     listCardDataTotal: listCardDataTotal,
    //   });
    // },
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(RedeemCodeDataDownload));
